import type { FeatureFlagOp } from '@shared';
import { WaterlilyClient, createQueryKeys } from '@/api/waterlily';

export const appConfigFeatureFlagsKeys = {
  ...createQueryKeys('appConfigFeatureFlags'),
  draft: () => ['appConfigFeatureFlags', 'draft'] as const,
};

export type AppConfigIds = {
  applicationId: string;
  environmentId: string;
  configurationProfileId: string;
};

export type AppConfigLabels = {
  applicationName: string | null;
  environmentName: string | null;
  configurationProfileName: string | null;
};

export type FetchAppConfigFeatureFlagsResponse = {
  config: AppConfigSchema;
  basedOnHash: string;
  appConfigIds: AppConfigIds;
  appConfigLabels: AppConfigLabels;
};

export type FeatureFlagDraft = {
  id: string;
  editorAdvisorId: string;
  basedOnHash: string;
  operations: FeatureFlagOp[];
  createdAt: string;
  updatedAt: string;
};

export type FetchFeatureFlagDraftResponse = {
  draft: FeatureFlagDraft | null;
};

export type PutFeatureFlagDraftBody = {
  basedOnHash: string;
  operations: FeatureFlagOp[];
};

export type PublishFeatureFlagResponse = {
  success: boolean;
  appConfigVersion: number;
  deploymentId: string;
  deploymentState: string;
  publishHistoryId: string;
  verificationStatus: 'SKIPPED' | 'MATCH' | 'MISMATCH' | 'FETCH_FAILED';
};

export const appConfigFeatureFlagsApi = {
  fetchConfig: () =>
    WaterlilyClient.get<FetchAppConfigFeatureFlagsResponse>('/wizard/app-config-feature-flags'),
  fetchDraft: () =>
    WaterlilyClient.get<FetchFeatureFlagDraftResponse>('/wizard/feature-flag-draft'),
  putDraft: (body: PutFeatureFlagDraftBody) =>
    WaterlilyClient.put<{ draft: FeatureFlagDraft }>('/wizard/feature-flag-draft', body),
  deleteDraft: () =>
    WaterlilyClient.delete<{ success: boolean }>('/wizard/feature-flag-draft'),
  publishDraft: (body: { basedOnHash: string }) =>
    WaterlilyClient.post<PublishFeatureFlagResponse>(
      '/wizard/feature-flag-publish',
      body,
    ),
};
